import type { SxProps, Theme } from '@mui/material/styles';

export const sectionSx: SxProps<Theme> = {
  py: 2,
  px: 3,
  backgroundColor: 'background.paper',
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: '16px',
  boxShadow: '0px 1px 4px rgba(15, 15, 15, 0.08)',
};
